import { Phone } from "lucide-react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import CtaBand from "@/components/CtaBand";
import { faqs, images, business } from "@/data/site";

const schema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  return (
    <>
      <Seo
        title="Roofing FAQ | Future Roofing and Repair — Bucks County, PA"
        description="Answers to common roofing questions: insurance claims, materials, warranties, and service areas in Bucks County, PA."
        keywords="Roofing FAQ Bucks County, Roof repair questions, Roofing insurance claims PA, Roofing warranties"
        schema={schema}
      />
      <PageHero
        kicker="Questions & Answers"
        title="Roofing FAQ"
        subtitle="Straight answers to the questions homeowners and businesses ask us most. Still not sure? Just give us a call."
        image={images.metal}
      />

      <section className="bg-cream">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                className="border border-charcoal/20 mb-3 bg-cream shadow-md"
                data-testid={`faq-item-${idx}`}
              >
                <AccordionTrigger className="font-accent uppercase text-base tracking-wide text-charcoal px-5 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="px-5 text-charcoal/80 leading-relaxed text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-10 text-center bg-cream-200 border border-charcoal/20 p-8">
            <h2 className="font-heading text-3xl uppercase text-charcoal">Still Have Questions?</h2>
            <p className="mt-2 text-charcoal/75">We're happy to help. Give us a call.</p>
            <a
              href={business.phoneHref}
              data-testid="faq-call"
              className="mt-5 inline-flex items-center gap-2 bg-rust text-cream border border-charcoal/20 shadow-md hover:-translate-y-0.5 transition-all font-heading text-xl uppercase px-6 py-3"
            >
              <Phone className="w-5 h-5" /> {business.phone}
            </a>
          </div>
        </div>
      </section>

      <CtaBand
        variant="default"
        kicker="Get Started"
        title="Ready to Fix Your Roof?"
        text="Request a free estimate or give us a call — we're happy to help with your roofing project."
      />
    </>
  );
}
